import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { THideCommentSucceed, EHideCommentActionType } from './types';

export const hideCommentSucceed: (id: number) => THideCommentSucceed = actionGenerator<
  EHideCommentActionType.Succeed,
  number
>(EHideCommentActionType.Succeed);
